import { useMapContext, useMapView } from "@evergis/react";
import { useMemo } from "react";
import { usePrintRectangle } from "./usePrintRectangle";

export const usePrintCenter = (): { x: number; y: number } => {
  const rectangle = usePrintRectangle();
  const { painter } = useMapContext();
  const { position, resolution } = useMapView();

  const { left, top, width, height } = rectangle;
  const xOffset = left + width / 2;
  const yOffset = top + height / 2;

  return useMemo(() => {
    const { x, y } = painter.getPointFromPxPosition(xOffset, yOffset);

    return { x, y };
  }, [xOffset, yOffset, position, resolution]);
};
